import printJS from "print-js";
import { IsMobile } from "./SharedUtils";


export const printDocument = (sFile, sTitle, callback) => {
  const isMobile = IsMobile();
  if (isMobile) {
    const aBytes = atob(sFile);
    const aBytesNumber = new Array(aBytes.length);
    for (let nCount = 0; nCount < aBytes.length; nCount++)
      aBytesNumber[nCount] = aBytes.charCodeAt(nCount);
    const aBytesArray = new Uint8Array(aBytesNumber);
    const oBlob = new Blob([aBytesArray], { type: "application/pdf" });
    const oBlobURL = URL.createObjectURL(oBlob);
    window.open(oBlobURL, "_blank");
    //! Code that generates a label and downloads the file with a custom name, does not support viewing
    // let oTag = document.createElement("a");
    // document.body.appendChild(oTag);
    // oTag.style = "display: none";
    // oTag.href = oBlobURL;
    // oTag.download = "Manual de usuario.pdf";
    // oTag.target = "_blank";
    // oTag.click();
    // Removing blob after 10 minutes
    setTimeout(() => {
      window.URL.revokeObjectURL(oBlobURL);
    }, (10 * 60 * 1000));
    if (callback) callback();
    return;
  }
  printJS({
    base64: true,
    printable: sFile,
    documentTitle: sTitle,
    modalMessage: "Cargando...",
    onPrintDialogClose: () => {
      if (callback) callback();
    },
  });
};
